export default [
	'DFW',
	'Houston',
	'Central',
	'East',
	'Valley',
	'Austin',
	'San Antonio',
	'West',
	'Other',
];